import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  emp_id: string;
}

export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
  };
  return header;
}

const getUserInfo = () => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  return jwtDecode<DecodedToken>(token);
};

const getPlanogramList = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/planogram-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};

export const getExportData = async (
  warehouse: any,
  product: string | null,
  accept: string | null
): Promise<any> => {
  const accept_language = accept === "Arabic" ? "ar" : "en";
  const warehouseIds: string = warehouse.selectedOption?.map((id: string) => `warehouseId=${id}`).join("&") || "";
  let url = `nwc/export/inventory?${warehouseIds}`;
  if (product) {
    url += `&productId=${product}`;
  }
  url += `&accept_language=${accept_language}`;

  const response = await axios.get<any>(url, {
    responseType: "blob",
    headers: getHeader(),
  });
  return response;
};

export const getDataTobePrinted = async (
  warehouse: any,
  product: string | null
): Promise<any> => {
  const warehouseIds: string = warehouse.selectedOption?.map((id: string) => `warehouseId=${id}`).join("&") || "";
  const response = await axios.get<any>(
    `nwc/inventory?${warehouseIds}&productId=${product}`,
    {
      headers: getHeader(),
    }
  );
  return response;
};

export const getInventoryData = async (
  warehouse: string | null,
  product: string | null
): Promise<any> => {
  const response = await fetch(
    `nwc/export/inventory/${warehouse}?productId=${product}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...getHeader(),
      },
    }
  );
  if (response.ok) {
    const data = await response.json();
    return data;
  }else {
    return null;
  }
};

export const getWarehouseData = async (): Promise<any> => {
  const response = await axios.get<any>(`/nwc/warehouse`, {
    headers: getHeader(),
  });
  return response;
};
export const getProductData = async (
  warehouse: any
): Promise<any> => {
  const warehouseIds: string = warehouse.selectedOption?.map((id: string) => `warehouseId=${id}`).join("&") || "";
  const response = await axios.get<any>(`/nwc/products?${warehouseIds}`, {
    headers: getHeader(),
  });
  return response;
};

export default getPlanogramList;
